import { EmployeeIdentificationType, EmploymentViewModel } from '@fora-monorepo/employer-my-pages-common/types';

const mockExactDuplicate: EmploymentViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001090',
  employmentStartDate: '2022-01-01',
  employmentEndDate: null,
  employee: {
    partnerNumberIndividual: '0032695303',
    employeeId: '199001055569',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'John',
    lastName: 'Guidetti',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: true,
  },
  employmentPeriods: [],
  markups: [],
  activeMarkup: null,
  hasFokParameterChoices: false,
  isInactive: true,
};

const mockPartialDuplicate: EmploymentViewModel[] = [
  {
    foraAgreementNumber: '00000000004010000783',
    policyNumber: '500000001090',
    employmentStartDate: '2022-01-01',
    employmentEndDate: null,
    employee: {
      partnerNumberIndividual: '0032695303',
      employeeId: '199001055569',
      identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
      firstName: 'John',
      lastName: 'Guidetti',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [],
    markups: [],
    activeMarkup: null,
    hasFokParameterChoices: false,
    isInactive: false,
  },
  {
    foraAgreementNumber: '00000000004010000783',
    policyNumber: '500000001093',
    employmentStartDate: '2022-01-01',
    employmentEndDate: null,
    employee: {
      partnerNumberIndividual: '0032695304',
      employeeId: '199501655569',
      identificationType: EmployeeIdentificationType.CoOrdinationNumber,
      firstName: 'Kosovare Frida',
      lastName: 'Asllani',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [],
    markups: [],
    activeMarkup: null,
    hasFokParameterChoices: false,
    isInactive: true,
  },
  {
    foraAgreementNumber: '00000000004010000755',
    policyNumber: '500000001047',
    employmentStartDate: '2023-01-01',
    employmentEndDate: null,
    employee: {
      partnerNumberIndividual: '0032695333',
      employeeId: '199501655443',
      identificationType: EmployeeIdentificationType.CoOrdinationNumber,
      firstName: 'Björne',
      lastName: 'Björnsson',
      address: {
        streetAddress: 'Street address',
        streetAddress2: '',
        postalCode: '11111',
        city: 'Stockholm',
        countryCode: 'SE',
      },
      birthDate: '',
      deathDate: '',
      isVerified: true,
    },
    employmentPeriods: [],
    markups: [],
    activeMarkup: null,
    hasFokParameterChoices: false,
    isInactive: true,
  },
];

export const mockPartialDuplicateEmployments = {
  noMatch: [],
  match: mockPartialDuplicate,
};
export const mockExactDuplicateEmployment = {
  noMatch: null,
  match: mockExactDuplicate,
};
